import { FormControl, FormControlProps, FormLabel, Text } from '@chakra-ui/react';
import MarkableMap from 'components/Organismos/MarkableMap';
import { Icon, LatLng } from 'leaflet';
import { Control, Controller, FieldError, FieldValues, Path } from 'react-hook-form';

const initialLatLng = new LatLng(0.028352, -51.065157)

type InputMapProps<T extends FieldValues> = FormControlProps & {
    name: Path<T>;
    label?: string;
    error?: FieldError;
    control: Control<T>;
    customIcon?: Icon;
}

const InputMap = <T extends FieldValues>({
    name,
    control,
    error,
    label,
    customIcon,
    ...rest
}: InputMapProps<T>) => {
    return (
        <FormControl {...rest} isInvalid={!!error}>
            {label && (
                <FormLabel>{label}</FormLabel>
            )}
            <Controller
                name={name}
                control={control}
                render={({ field: { onChange, value } }) => {
                    const asLatLng = value ? new LatLng(value.latitude, value.longitude) : null;
                    return (
                        <MarkableMap
                            center={asLatLng ?? initialLatLng}
                            zoom={10}
                            zoomControl
                            customIcon={customIcon}
                            onMarkerSet={(latLng) => onChange({ latitude: latLng.lat, longitude: latLng.lng })}
                            initialMarker={asLatLng}
                            style={{ height: 250, width: '100%', borderRadius: 10 }}
                        >

                        </MarkableMap>
                    )
                }}
            />
            {error && (
                <Text fontSize="xs" color="red.300" mt={3}>{error.message}</Text>
            )}
        </FormControl>
    )
}

export default InputMap